(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fika-bridge-fixed-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[id^="fika-bridge-"]');

  sections.forEach(function (section) {

    /* ── Entrada con Intersection Observer ────── */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fika-bridge--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    observer.observe(section);

    /* ── Pausa de animación al hover del círculo ── */
    var orbit = section.querySelector('.fika-bridge__orbit');
    if (!orbit) return;

    var dots = section.querySelectorAll('.fika-bridge__dot-inner');

    section.querySelector('.fika-bridge__circle').addEventListener('mouseenter', function () {
      orbit.style.animationPlayState = 'paused';
      dots.forEach(function (d) { d.style.animationPlayState = 'paused'; });
    });

    section.querySelector('.fika-bridge__circle').addEventListener('mouseleave', function () {
      orbit.style.animationPlayState = 'running';
      dots.forEach(function (d) { d.style.animationPlayState = 'running'; });
    });

    /* ── Reducir movimiento si el usuario lo prefiere ── */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      orbit.style.animation = 'none';
      dots.forEach(function (d) { d.style.animation = 'none'; });
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fika-personas-bento-v3"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── Intersection Observer — animación de entrada ─── */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var delay = parseInt(e.target.dataset.fbDelay || 0, 10);
      setTimeout(function () { e.target.classList.add('fb-visible'); }, delay);
      io.unobserve(e.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-fb-in]').forEach(function (el) { io.observe(el); });

  /* ── Sistema de burbujas orbitales ───────────────── */
  document.querySelectorAll('.fika-bento').forEach(function (section) {
    var bubblesEl = section.querySelector('.fika-bubbles');
    var cardsEl   = section.querySelector('.fb-cards-layer');
    if (!bubblesEl || !cardsEl) return;

    var bubbles    = bubblesEl.querySelectorAll('.fb-bubble:not(.fb-bubble--stat)');
    var activeCard = null;

    /* — Abre la tarjeta de una persona — */
    function open(cardIndex) {
      close();

      var card = cardsEl.querySelector('.fb-card[data-card-index="' + cardIndex + '"]');
      if (!card) return;

      activeCard = card;
      bubblesEl.classList.add('fb-has-open');
      card.classList.add('fb-card--active');

      /* Foco accesible al botón de cierre */
      var btn = card.querySelector('.fb-card__close');
      if (btn) setTimeout(function () { btn.focus(); }, 380);

      /* Listeners de cierre con pequeño delay para ignorar el click que abrió */
      setTimeout(function () {
        document.addEventListener('click', outsideClick);
        document.addEventListener('keydown', escapeKey);
      }, 40);
    }

    /* — Cierra la tarjeta activa — */
    function close() {
      if (!activeCard) return;
      activeCard.classList.remove('fb-card--active');
      bubblesEl.classList.remove('fb-has-open');
      activeCard = null;
      document.removeEventListener('click', outsideClick);
      document.removeEventListener('keydown', escapeKey);
    }

    /* — Click fuera de la tarjeta — */
    function outsideClick(e) {
      if (!activeCard) return;
      if (!activeCard.contains(e.target)) close();
    }

    /* — Tecla Escape — */
    function escapeKey(e) {
      if (e.key === 'Escape') close();
    }

    /* — Bind en burbujas — */
    bubbles.forEach(function (bubble) {
      var cardIdx = bubble.dataset.card;

      bubble.addEventListener('click', function (e) {
        e.stopPropagation();
        open(cardIdx);
      });

      bubble.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(cardIdx);
        }
      });
    });

    /* — Bind en botones de cierre — */
    cardsEl.querySelectorAll('.fb-card').forEach(function (card) {
      var btn = card.querySelector('.fb-card__close');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          close();
        });
      }
    });
  });

  /* ── Touch: fb-moment revela sub en móvil ────────── */
  if ('ontouchstart' in window) {
    document.querySelectorAll('.fb-moment').forEach(function (m) {
      m.addEventListener('click', function () {
        m.classList.toggle('fb-moment--tapped');
      });
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fika-personas-fixed"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── Intersection Observer para animaciones de entrada ── */
  var animEls = document.querySelectorAll('[data-fp-animate]');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var delay = parseInt(entry.target.dataset.delay || 0, 10);
      setTimeout(function () {
        entry.target.classList.add('fp-visible');
      }, delay);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });

  animEls.forEach(function (el) { io.observe(el); });

  /* ── Acordeones toggle ────────────────────────────────── */
  var toggles = document.querySelectorAll('.fika-persona-card__toggle');

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card    = btn.closest('.fika-persona-card');
      var scenes  = card.querySelector('.fika-persona-card__scenes');
      var isOpen  = btn.getAttribute('aria-expanded') === 'true';

      /* Cierra todos los de la misma sección primero */
      var allCards = btn.closest('.fika-personas').querySelectorAll('.fika-persona-card');
      allCards.forEach(function (c) {
        var otherBtn    = c.querySelector('.fika-persona-card__toggle');
        var otherScenes = c.querySelector('.fika-persona-card__scenes');
        if (c !== card && otherBtn && otherScenes) {
          otherBtn.setAttribute('aria-expanded', 'false');
          otherScenes.setAttribute('aria-hidden', 'true');
          var otherTxt = otherBtn.querySelector('.fika-persona-card__toggle-text');
          if (otherTxt && otherTxt.dataset.labelClosed) {
            otherTxt.textContent = otherTxt.dataset.labelClosed;
          }
        }
      });

      /* Toggle actual */
      var txtEl = btn.querySelector('.fika-persona-card__toggle-text');
      if (!txtEl.dataset.labelClosed) {
        txtEl.dataset.labelClosed = txtEl.textContent;
        txtEl.dataset.labelOpen   = btn.dataset.labelOpen || 'Cerrar';
      }

      if (isOpen) {
        btn.setAttribute('aria-expanded', 'false');
        scenes.setAttribute('aria-hidden', 'true');
        txtEl.textContent = txtEl.dataset.labelClosed;
      } else {
        btn.setAttribute('aria-expanded', 'true');
        scenes.setAttribute('aria-hidden', 'false');
        txtEl.textContent = txtEl.dataset.labelOpen;
        /* Scroll suave para ver el acordeón */
        setTimeout(function () {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 80);
      }
    });
  });

  /* ── Tabs dentro de cada acordeón ────────────────────── */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.fika-persona-card__scene-tab');
    if (!tab) return;

    var inner   = tab.closest('.fika-persona-card__scenes-inner');
    var panels  = inner.querySelectorAll('.fika-persona-card__scene-panel');
    var tabs    = inner.querySelectorAll('.fika-persona-card__scene-tab');
    var idx     = parseInt(tab.dataset.sceneTab, 10);

    tabs.forEach(function (t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    panels.forEach(function (p) { p.classList.remove('is-active'); });

    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');
    var target = inner.querySelector('[data-scene-panel="' + idx + '"]');
    if (target) target.classList.add('is-active');
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fika-video-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionId  = '{{ section.id }}';
  var track      = document.getElementById('fika-track-' + sectionId);
  var dotsWrap   = document.getElementById('fika-dots-' + sectionId);

  if (!track || !dotsWrap) return;

  var dots      = Array.from(dotsWrap.querySelectorAll('.fika-videos__dot'));
  var allCards  = Array.from(track.querySelectorAll('[data-fika-card]'));
  var isDragging   = false;
  var startX       = 0;
  var scrollStart  = 0;
  var dragDelta    = 0;

  /* ── IntersectionObserver: coverflow + autoplay ──────────────── */
  /*
    Usamos dos umbrales:
    • 0.75 → suficientemente centrado → activar (play + clase is-active)
    • 0    → salió → desactivar (pause)
    root = track para que la intersección se calcule relativa al carrusel,
    no al viewport completo.
  */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card  = entry.target;
        var video = card.querySelector('[data-fika-video]');

        if (entry.isIntersecting && entry.intersectionRatio >= 0.75) {
          card.classList.add('is-active');
          if (video) {
            /* preload diferido: solo descargamos cuando entra al viewport */
            if (video.preload === 'none') video.preload = 'metadata';
            video.play().catch(function () {});
            card.classList.add('is-playing');
          }
        } else {
          card.classList.remove('is-active');
          if (video && !video.paused) {
            video.pause();
            card.classList.remove('is-playing');
          }
        }
      });
    }, {
      root:       track,
      threshold:  [0, 0.75]
    });

    allCards.forEach(function (c) { io.observe(c); });
  }

  /* ── Fade-in del video al cargar metadatos ───────────────────── */
  track.querySelectorAll('[data-fika-video]').forEach(function (v) {
    v.addEventListener('loadeddata', function () {
      v.classList.add('is-loaded');
    });
    /* Si ya estaba cargado (caché) */
    if (v.readyState >= 2) v.classList.add('is-loaded');
  });

  /* ── Click en tarjeta: play / pause ─────────────────────────── */
  allCards.forEach(function (card) {
    if (!card.hasAttribute('data-fika-video-card')) return;
    card.addEventListener('click', function (e) {
      if (dragDelta > 5) return;
      /* El botón mute tiene su propio handler */
      if (e.target.closest('[data-fika-mute]')) return;
      /* Links externos no deben interceptarse */
      if (e.target.closest('a')) return;

      var video = card.querySelector('[data-fika-video]');
      if (!video) return;

      if (video.paused) {
        video.play().catch(function () {});
        card.classList.add('is-playing');
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });
  });

  /* ── Botón mute ─────────────────────────────────────────────── */
  track.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fika-mute]');
    if (!btn) return;
    var card  = btn.closest('[data-fika-video-card]');
    var video = card && card.querySelector('[data-fika-video]');
    if (!video) return;

    video.muted = !video.muted;
    btn.classList.toggle('is-unmuted', !video.muted);
  });

  /* ── Actualizar dots al hacer scroll ────────────────────────── */
  track.addEventListener('scroll', function () {
    var cardW       = allCards[0] ? allCards[0].offsetWidth + 14 : 1;
    var activeIndex = Math.round(track.scrollLeft / cardW);
    dots.forEach(function (dot, i) {
      dot.classList.toggle('fika-videos__dot--active', i === activeIndex);
    });
  }, { passive: true });

  /* ── Drag to scroll (ratón) ─────────────────────────────────── */
  track.addEventListener('mousedown', function (e) {
    isDragging  = true;
    dragDelta   = 0;
    startX      = e.pageX - track.offsetLeft;
    scrollStart = track.scrollLeft;
    track.style.cursor = 'grabbing';
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    e.preventDefault();
    var walk  = (e.pageX - track.offsetLeft - startX) * 1.4;
    dragDelta = Math.abs(walk);
    track.scrollLeft = scrollStart - walk;
  });

  document.addEventListener('mouseup', function () {
    isDragging = false;
    track.style.cursor = 'grab';
    /* Resetear dragDelta con un pequeño delay para que el click handler lo lea */
    setTimeout(function () { dragDelta = 0; }, 60);
  });

  /* Bloquear apertura de links si el usuario estaba arrastrando */
  track.addEventListener('click', function (e) {
    if (dragDelta > 5) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
